import React, { useContext } from "react";
import styles from "./index.module.scss";
import { Button } from "antd";
import Space from "../../../../../components/Space";
import { SortType } from "../../../../../service/discuss";
import { DiscussContent } from "../../context";

interface FilterItem {
    type: SortType;
    title: string;
}

export default function TopicTools() {
    const { sort, setSort } = useContext(DiscussContent);

    const filters: FilterItem[] = [
        { type: SortType.All, title: "全部" },
        { type: SortType.Hot, title: "热门" },
        { type: SortType.New, title: "最新" },
        { type: SortType.Blocked, title: "屏蔽" }
    ];

    return (
        <div className={styles.root}>
            <Space className={styles.segment} size={15}>
                {filters.map(item => (
                    <Button
                        key={item.type}
                        type={sort === item.type ? "primary" : "default"}
                        onClick={() => setSort(item.type)}>
                        {item.title}
                    </Button>
                ))}
            </Space>
        </div>
    );
}
